// list of feature flags available. Should be kept to a maximum of 2.
// store in the form:
// const features = {
//   FEATURE_ONE: 'feature_one',
//   FEATURE_TWO: 'feature_two',
// }
const FEATURES = {};

export default FEATURES;
